// extracted by mini-css-extract-plugin
export var aiStarSpin = "_qi-1";
export var spinner = "_qi-0";